var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRipple = function SvgRipple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    preserveAspectRatio: "xMidYMid",
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "0 0"
    },
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#523729",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "spline",
    dur: "2.5s",
    keySplines: "0 0.2 0.8 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "0;46"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0s",
    calcMode: "spline",
    dur: "2.5s",
    keySplines: "0.2 0 0.8 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 0,
    fill: "none",
    stroke: "#bcb3ac",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-1.1111111111111112s",
    calcMode: "spline",
    dur: "2.5s",
    keySplines: "0 0.2 0.8 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "0;46"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.1111111111111112s",
    calcMode: "spline",
    dur: "2.5s",
    keySplines: "0.2 0 0.8 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))));
};
export default SvgRipple;